import { useParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import BASE_URL from "../../../BASEURL";

export default function EditAddress() {

  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({ city: "", address: "", phone: "" });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    async function fetchAddress() {
      setLoading(true);
      setError("");
      try {
        const res = await fetch(`${BASE_URL}/api/address/${id}`);
        if (!res.ok) throw new Error("Address not found");
        const result = await res.json();
        setForm(result.data || result.address || result);
      } catch (err) {
        setError(err.message || "Failed to fetch address");
      } finally {
        setLoading(false);
      }
    }
    fetchAddress();
  }, [id]);

  const handleChange = (key, value) => {
    setForm({ ...form, [key]: value });
  };

  const handleUpdate = async () => {
    setLoading(true);
    setError("");
    setSuccess("");
    try {
      const res = await fetch(`${BASE_URL}/api/address/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error("Failed to update address");
      setSuccess("Address updated successfully!");
      setTimeout(() => navigate(-1), 1200);
    } catch (err) {
      setError(err.message || "Failed to update address");
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <p className="p-6">Loading...</p>;
  if (error) return <p className="p-6 text-red-500">{error}</p>;

  return (
    <div className="max-w-5xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-6 text-primary">Edit Address</h1>

      <div className="bg-white p-6 rounded shadow space-y-4">
        {success && <p className="text-green-600 mb-2">{success}</p>}
        {error && <p className="text-red-500 mb-2">{error}</p>}
        <input
          className="w-full border p-2 rounded"
          value={form.city}
          onChange={(e) => handleChange("city", e.target.value)}
        />

        <textarea
          className="w-full border p-2 rounded"
          value={form.address}
          onChange={(e) => handleChange("address", e.target.value)}
        />

        <input
          className="w-full border p-2 rounded"
          value={form.phone}
          onChange={(e) => handleChange("phone", e.target.value)}
        />

        <div className="flex justify-end gap-3">
          <button onClick={() => navigate(-1)} className="border px-4 py-2 rounded">
            Cancel
          </button>
          <button
            className="bg-primary text-white px-6 py-2 rounded"
            onClick={handleUpdate}
            disabled={loading}
          >
            {loading ? "Updating..." : "Update Address"}
          </button>
        </div>
      </div>
    </div>
  );
}
